export default {
  'Lucky you! Payment is not required.': 'أنت محظوظ! لا يتطلب الدفع.',
  'Payment is done successfully.': 'تم الدفع بنجاح.',
  'Please select the preferable payment method.': 'يرجى اختيار طريقة الدفع المفضلة.',
  'Pay online now': 'ادفع عبر الإنترنت الآن',
  'Bank transfer': 'حوالة بنكية',
  'Pay sales representative by cheque': 'دفع مندوب المبيعات عن طريق شيك',
  'Cash deposit slip': 'إيصال إيداع نقدي',
  'Direct Debit from Emirates Islamic and ENBD bank accounts': 'خصم مباشر من حسابات بنك الإمارات الإسلامي وبنك الإمارات دبي الوطني',
  'Pay by link': 'الدفع عن طريق الرابط',
  'Payment after approval': 'الدفع بعد الموافقة',
  'Customer will pay after approval.': 'سيدفع العميل بعد الموافقة.',
  //
  'Payment reference': 'مرجع الدفع',
  'Payment date': 'تاريخ الدفع',
  'Payment by card is available.': 'الدفع عن طريق البطاقة متاح.',
  Proceed: 'متابعة',
  //
  'Payment requisites': 'متطلبات الدفع',
  'Please quote the company legal name as a payment reference.': 'يرجى ذكر الاسم القانوني للشركة كمرجع للدفع.',
  'Bank transfer payment please remit to:': 'الدفع عن طريق التحويل البنكي يرجى التحويل إلى:',
  'Account holder: {{accountName}}': 'صاحب الحساب: {{accountName}}',
  'IBAN: {{iban}}': 'IBAN: {{iban}}',
  'Bank name: {{bankName}}': 'اسم البنك: {{bankName}}',
  'Copy requisites': 'نسخ المتطلبات',
  'Upload payment confirmation': 'إرفاق تأكيد الدفع',
  //
  'You can pay by Direct Debit with your bank account:': 'يمكنك الدفع عن طريق الخصم المباشر من حسابك المصرفي:',
  //
  'Transaction successful.': 'تمت العملية بنجاح.',
  'A payment link was sent to email <strong>{{ lastEmail }}</strong>': 'تم إرسال رابط الدفع إلى البريد الإلكتروني <strong>{{ lastEmail }}</strong>',
  'A payment link will be sent to the specified email': 'سيتم إرسال رابط الدفع إلى البريد الإلكتروني المحدد',
  'Resend a link': 'إعادة إرسال الرابط',
  'Send a link': 'إرسال رابط',
  //
  'This is the final step. We will notify you by email once your application is approved.': 'هذه هي الخطوة الأخيرة. سنقوم بإعلامك عبر البريد الإلكتروني بمجرد الموافقة على طلبك.',
  //
  'Something went wrong': 'حدث خطأ ما',
  'Close and Try again': 'إغلاق وإعادة المحاولة',
  'An error has been occurred.': 'حدث خطأ.',
  'Please try again later or choose another payment method.': 'يرجى المحاولة مرة أخرى لاحقًا أو اختيار طريقة دفع أخرى.',
};
